import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AncillaryServicesListComponent
} from "libraries/component/ancillary-services-list/ancillary-services-list.component";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { IframeAppEmbedderModule } from "libraries/component/iframe-app-embedder/iframe-app-embedder.module";

@NgModule({
    declarations: [
        AncillaryServicesListComponent,
    ],
    exports: [
        AncillaryServicesListComponent,
    ],
    imports: [
        CommonModule,
        LoaderModule,
        NotificationModule,
        IframeAppEmbedderModule,
    ]
})
export class AncillaryServicesListModule {
}
